import moment from 'jalali-moment';

export default function isoDateToDate(isoDate: string): string {
  const gregorianDate = moment(isoDate).toDate();

  return moment(gregorianDate)
    .locale('en')
    .format('HH:mm:ss YYYY/MM/DD');
}
